<div class="box" [formGroup]="portaForm">
    <div class="has-text-left">
        <div class="columns is-aligned-center">
            <div class="column">
                <p class="title is-level-5 has-text-weight-semibold">
                    <span>
                        Je conserve mon numéro
                        @if (isFai) {
                            <span>fixe</span>
                        } @else {
                            <span>mobile</span>
                        }
                    </span>
                </p>
                @if (portaPromo) {
                    @if (portaPromo.message.portability_non) {
                        @if (!portaForm.controls.checked.value) {
                            <p class="text is-level-2 is-marginless has-text-weight-bold">
                                {{ portaPromo.message.portability_non }}
                            </p>
                        }
                    }
                    @if (portaPromo.message.portability_yes) {
                        @if (portaForm.controls.checked.value) {
                            <p class="text is-level-2 is-marginless has-text-weight-bold">
                                {{ portaPromo.message.portability_yes }}
                            </p>
                        }
                    }
                }
                <p class="text is-level-2 is-marginless">
                    En choisissant de conserver votre numéro, vous nous mandatez pour résilier votre forfait auprès de
                    votre ancien opérateur, transférer votre numéro et activer votre nouvelle ligne.
                </p>
            </div>
            <div class="column is-narrow">
                <div class="radios is-flex-nowrap is-horizontal-mobile">
                    <div class="radio-tile is-horizontal is-narrow-desktop is-marginless">
                        <input
                            type="radio"
                            formControlName="checked"
                            [value]="true"
                            id="portability_choice_yes{{ quoteIndex }}"
                        />
                        <label
                            checkoutCy="porta_yes_{{ quoteIndex }}"
                            for="portability_choice_yes{{ quoteIndex }}"
                            class="radio-label"
                        >
                            <span><span class="radio-title">Oui</span></span>
                        </label>
                    </div>
                    <div class="radio-tile is-horizontal is-narrow-desktop is-marginless">
                        <input
                            type="radio"
                            id="portability_choice_no{{ quoteIndex }}"
                            formControlName="checked"
                            [value]="false"
                        />
                        <label
                            checkoutCy="porta_no_{{ quoteIndex }}"
                            for="portability_choice_no{{ quoteIndex }}"
                            class="radio-label"
                        >
                            <span><span class="radio-title">Non</span></span>
                        </label>
                    </div>
                </div>
                @if (isSubmitted && portaForm.invalid && portaForm.get('checked').value) {
                    <ul class="help is-error column is-12">
                        <li class="has-text-right">Merci d'indiquer votre choix de portabilité.</li>
                    </ul>
                }
            </div>
        </div>
        <ng-template #rioText let-isFai>
            @if (!isFai) {
                <p>
                    <span class="has-text-weight-semibold">Appeler le 3179&nbsp;</span>
                    <span>pour connaitre votre n° de RIO</span>
                </p>
            }
            @if (isFai) {
                <p class="text is-level-3 is-marginless">
                    Pour obtenir votre RIO,
                    <span class="has-text-weight-semibold">appelez gratuitement le 3179 depuis votre ligne fixe</span>
                    ou consultez la rubrique "plus d'infos" ci-dessous
                </p>
            }
        </ng-template>
        @if (portaForm.get('checked').value) {
            <ng-container [formGroup]="rioTelForm">
                <div class="divider"></div>
                <div class="columns is-multiline is-flex is-aligned-center">
                    <div class="column is-6">
                        <div class="columns is-multiline">
                            <div class="column is-12">
                                @if (!phoneField.hide) {
                                    <div class="field">
                                        <div class="control has-dynamic-placeholder has-icons-right">
                                            <input
                                                checkoutCy="porta_phone_{{ quoteIndex }}"
                                                checkoutFormClass
                                                [formClassErrorControl]="rioTelForm.get('noTelephoneAPorter')"
                                                class="input is-focused"
                                                formControlName="noTelephoneAPorter"
                                                id="phone{{ quoteIndex }}"
                                                maxlength="10"
                                                minlength="10"
                                                placeholder="N° de téléphone à conserver *"
                                                type="text"
                                                checkoutCsMask
                                                (keydown)="validatePhone($event)"
                                                (paste)="validatePhone($event)"
                                            />
                                            <label>n° de téléphone</label>
                                            @if (portaForm.get('eligPorta').pending) {
                                                <span class="icon is-small is-rotating">
                                                    <i class="tri-logo"></i>
                                                </span>
                                            } @else {
                                                @if (rioTelForm.get('noTelephoneAPorter').dirty) {
                                                    <span class="icon is-small">
                                                        @if (rioTelForm.get('noTelephoneAPorter').valid) {
                                                            <i class="tri-check-circle"></i>
                                                        }
                                                        @if (rioTelForm.get('noTelephoneAPorter').invalid) {
                                                            <i class="tri-exclamation-circle"></i>
                                                        }
                                                    </span>
                                                }
                                            }
                                        </div>
                                        @if (rioTelForm.get('noTelephoneAPorter').errors &&
                                        rioTelForm.get('noTelephoneAPorter').dirty) {
                                            @if (rioTelForm.get('noTelephoneAPorter').errors.required) {
                                                <p class="text help is-error">Numéro requis</p>
                                            }
                                            @if (rioTelForm.get('noTelephoneAPorter').errors.phone) {
                                                <p class="text help is-error">
                                                    {{ rioTelForm.get('noTelephoneAPorter').errors.phone }}
                                                </p>
                                            }
                                        }
                                    </div>
                                }
                            </div>
                            <div class="column is-12">
                                <div class="field mt-3">
                                    <p>
                                        <ng-container
                                            [ngTemplateOutlet]="rioText"
                                            [ngTemplateOutletContext]="{ $implicit: isFai }"
                                        ></ng-container>
                                    </p>
                                    <div class="control has-dynamic-placeholder has-icons-right">
                                        <input
                                            checkoutCy="porta_rio_{{ quoteIndex }}"
                                            checkoutFormClass
                                            [formClassErrorControl]="rioTelForm.get('codeRio')"
                                            class="input is-focused"
                                            formControlName="codeRio"
                                            id="rio{{ quoteIndex }}"
                                            maxlength="12"
                                            minlength="12"
                                            placeholder="N° de RIO *"
                                            type="text"
                                            checkoutCsMask
                                            (input)="toUpperCase($event)"
                                            (paste)="toUpperCase($event)"
                                        />
                                        <label for="rio{{ quoteIndex }}">n° de RIO</label>
                                        @if (portaForm.get('eligPorta').pending) {
                                            <span class="icon is-small is-rotating">
                                                <i class="tri-logo"></i>
                                            </span>
                                        } @else {
                                            @if (rioTelForm.get('codeRio').dirty) {
                                                <span class="icon is-small">
                                                    @if (rioTelForm.get('codeRio').valid) {
                                                        <i class="tri-check-circle"></i>
                                                    }
                                                    @if (rioTelForm.get('codeRio').invalid) {
                                                        <i class="tri-exclamation-circle"></i>
                                                    }
                                                </span>
                                            }
                                        }
                                    </div>
                                    @if (rioTelForm.get('codeRio').errors && rioTelForm.get('codeRio').dirty) {
                                        @if (rioTelForm.get('codeRio').errors.required) {
                                            <p class="text help is-error">RIO requis</p>
                                        }
                                        @if (rioTelForm.get('codeRio').errors.rio) {
                                            <p
                                                class="text help is-error"
                                                [innerHTML]="rioTelForm.get('codeRio').errors.rio"
                                            ></p>
                                        }
                                    }
                                    @if (portaForm.get('eligPorta')?.errors?.apiError) {
                                        <p class="text help is-error">
                                            {{ portaForm.get('eligPorta').errors.apiError }}
                                        </p>
                                    }
                                </div>
                                @if (rioPromo) {
                                    <div>{{ rioPromo.message.portability_other }}</div>
                                }
                            </div>
                        </div>
                    </div>
                    @if (!isFai) {
                        <div class="column is-6 has-background-info-fade is-shadowless box is-flex">
                            <p class="icon-and-text has-text-weight-semibold">
                                <span class="icon is-medium">
                                    <i class="tri-stopwatch"></i>
                                </span>
                                <span>Votre numéro est transféré&nbsp;sous 3 jours ouvrés !</span>
                            </p>
                            <p class="text">En attendant, vous pouvez :</p>
                            <ul class="list">
                                <li class="list-item">
                                    <div class="list-item-content">
                                        <p class="text">
                                            Utiliser votre nouvelle SIM avec un
                                            <strong>numéro provisoire reçu par e-mail</strong>
                                        </p>
                                    </div>
                                </li>
                                <div class="divider porta-divider">
                                    <p class="divider-content has-background-info-fade">
                                        <span class="text">ou</span>
                                    </p>
                                </div>
                                <li class="list-item">
                                    <div class="list-item-content">
                                        <p class="text">
                                            Utiliser votre ancienne SIM jusqu&apos;au transfert de votre numéro actuel
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    }
                </div>
                <div class="is-paddingless columns">
                    @if (isFai && rioList) {
                        <div id="accordion" class="accordion column is-10-desktop is-9-fullhd">
                            <details class="accordion-item">
                                <summary class="accordion-header">
                                    <p class="text">Plus d'infos</p>
                                </summary>
                                <div class="accordion-body">
                                    <p>
                                        Si vous ne pouvez pas appeler le 3179 depuis votre ligne fixe, vous pouvez
                                        joindre le numéro correspondant à votre ancien operateur depuis n'importe quel
                                        téléphone fixe ou mobile
                                    </p>
                                    <div class="columns is-multiline">
                                        @for (rio of rioList; track rio) {
                                            <div
                                                class="column is-6"
                                            >
                                                <div
                                                    class="columns is-mobile">
                                                    <div class="column">
                                                        {{ rio.provider }}
                                                    </div>
                                                    <div class="column" style="text-wrap-mode: nowrap ">
                                                        {{ rio.phoneNumber | landlineNumber }}
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </details>
                        </div>
                    }
                </div>
            </ng-container>
        }
    </div>
</div>
